import { put, call } from 'redux-saga/effects';
import { map } from 'lodash';
import { actionSuccess, actionFailed } from 'shared/actions';
import axios from 'axios';
import { GET_GENDER_SUCCESS, GET_GENDER_FAILED } from './constants';

function genderApi() {
	return axios.request({
		url: `${process.env.REACT_APP_API_URL}ref-data/gender`,
		method: 'GET'
	});
}

export function* genderSaga() {
	try {
		const {
			data: { data }
		} = yield call(genderApi);
		const customData = map(data, ({ code, name }) => {
			return {
				key: code,
				text: name,
				value: code
			};
		});

		yield put(actionSuccess(GET_GENDER_SUCCESS, customData));
	} catch (error) {
		yield put(actionFailed(GET_GENDER_FAILED, []));
	}
}
